import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

export default class ToolBarSpacerViewModel extends ControlViewModel {

    /**
     * Das ViewModel fuer die ToolBar spacer
     * @param {object} params - Ein Objekt mit Optionen f�r das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
    }

}

ComponentManager.setViewModel('ToolBarSpacerViewModel', ToolBarSpacerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');